import {useMemo} from 'react';
import {useQuery} from 'react-query';

export const createGetOneHook = (service, keyId, name, mapPayload = v => v) => {
  return (params, queryConfig = {}) => {
    const relatedKey = useMemo(() => params?.[keyId], [params]);

    const config = useMemo(() => {
      // Provide stable default options to avoid unnecessary double refetches on mount/focus/reconnect
      // Callers can still override any of these through queryConfig
      return {
        enabled: !!relatedKey,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        ...queryConfig,
      };
    }, [relatedKey, queryConfig]);

    // Memoize query function by related key to avoid creating a new function every render,
    // which can trigger duplicate requests in StrictMode/dev.
    const queryFn = useMemo(() => {
      return async () => {
        const {data} = await service.getOne(relatedKey);
        return {
          data: mapPayload(data)
        };
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [relatedKey]);

    // Use a consistent query key order across the app: [resourceName, id]
    return useQuery([name, relatedKey], queryFn, config);
  };
};
